<template>
    <div>
        <h1>Objednávka exkurze</h1>
        <ssv-order-header-school-excursion/>
        <ssv-order-billing-information-container required ref="billingInformation" hide-mailing-address/>
        <ssv-order-contact-information-container required ref="contactInformation" hide-descriptions/>
        <ssv-order-note placeholder="odhadovaný počet studentů, preferovaný den v týdnu…"/>
    </div>
</template>

<script>
    import SsvOrderBillingInformationContainer from '../billing-information/BillingInformationContainer';
    import SsvOrderContactInformationContainer from '../contact-information/ContactInformationContainer';
    import SsvOrderNote from '../parameters/OrderNote';
    import SsvOrderHeaderSchoolExcursion from '../header/HeaderSchoolExcursion'

    export default {
        name:       'SsvOrderSchoolExcursion',
        components: {
            SsvOrderHeaderSchoolExcursion,
            SsvOrderNote,
            SsvOrderContactInformationContainer,
            SsvOrderBillingInformationContainer
        },
        methods:    {
            validate() {
                this.$refs.billingInformation.validate();
                this.$refs.contactInformation.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/order/SchoolExcursion.vue